"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.getTipCoordinates = exports.getContentCoordinates = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));

var _parseInt = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/parse-int"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _helpers = require("@paprika/helpers");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var rotate = {
  top: 180,
  right: 270,
  bottom: 0,
  left: 90
};
var edgePadding = (0, _parseInt["default"])(_tokens["default"].space, 10);

var getAdjustedContentCoordinates = function getAdjustedContentCoordinates(_ref) {
  var x = _ref.x,
      y = _ref.y,
      contentRect = _ref.contentRect,
      targetRect = _ref.targetRect,
      scrollRect = _ref.scrollRect,
      align = _ref.align,
      offset = _ref.offset;
  var viewport = {
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  };
  var boundary = {
    top: scrollRect ? scrollRect.top : 0,
    right: scrollRect ? Math.min(scrollRect.right, viewport.width) : viewport.width,
    bottom: scrollRect ? Math.min(scrollRect.bottom, viewport.height) : viewport.height,
    left: scrollRect ? scrollRect.left : 0
  };
  var alignVert = ["bottom", "top"].includes(align);
  var isOnRightSide = targetRect.x + targetRect.width / 2 > boundary.left + (boundary.right - boundary.left) / 2;
  var isOnBottomHalf = targetRect.y + targetRect.height / 2 > boundary.top + (boundary.bottom - boundary.top) / 2;
  var overflowsViewportLeft = x < boundary.left;
  var overflowsViewportRight = x + contentRect.width > boundary.right;
  var overflowsViewportTop = y < boundary.top;
  var overflowsViewportBottom = y + contentRect.height > boundary.bottom;
  var newX = (0, _isNan["default"])(x) ? 0 : x;
  var newY = (0, _isNan["default"])(y) ? 0 : y;

  if (overflowsViewportLeft && !isOnRightSide) {
    newX = alignVert ? boundary.left + edgePadding : newX = targetRect.x + targetRect.width + offset;
  }

  if (overflowsViewportRight && isOnRightSide) {
    newX = alignVert ? boundary.right - contentRect.width - edgePadding : targetRect.x - contentRect.width - offset;
  }

  if (overflowsViewportTop && !isOnBottomHalf) {
    newY = alignVert ? targetRect.y + targetRect.height + offset : boundary.top + edgePadding;
  }

  if (overflowsViewportBottom && isOnBottomHalf) {
    newY = alignVert ? y - (contentRect.height + offset * 2 + targetRect.height) : boundary.bottom - contentRect.height - edgePadding;
  }

  return {
    x: newX,
    y: newY
  };
};

var getAnchor = function getAnchor(rect, align) {
  var positions = {
    top: function top() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top
      };
    },
    right: function right() {
      return {
        x: rect.right,
        y: rect.y + rect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: rect.left + rect.width / 2,
        y: rect.y + rect.height
      };
    },
    left: function left() {
      return {
        x: rect.left,
        y: rect.y + rect.height / 2
      };
    }
  };
  return positions[align]();
};

var getContentCoordinates = function getContentCoordinates(_ref2) {
  var _alignedPosition;

  var rect = _ref2.rect,
      targetRect = _ref2.targetRect,
      scrollRect = _ref2.scrollRect,
      align = _ref2.align,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 12 : _ref2$offset,
      edge = _ref2.edge;
  var anchor = getAnchor(targetRect, align);

  var getContentXByEdge = function getContentXByEdge() {
    if (edge === _helpers.AlignTypes.LEFT) {
      return anchor.x - targetRect.width / 2;
    }

    if (edge === _helpers.AlignTypes.RIGHT) {
      return anchor.x - rect.width + targetRect.width / 2;
    }

    return anchor.x - rect.width / 2;
  };

  var alignedPosition = (_alignedPosition = {}, (0, _defineProperty3["default"])(_alignedPosition, _helpers.AlignTypes.TOP, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y - (rect.height + offset),
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _helpers.AlignTypes.RIGHT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x + offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _helpers.AlignTypes.BOTTOM, function () {
    return getAdjustedContentCoordinates({
      x: getContentXByEdge(),
      y: anchor.y + offset,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), (0, _defineProperty3["default"])(_alignedPosition, _helpers.AlignTypes.LEFT, function () {
    return getAdjustedContentCoordinates({
      x: anchor.x - rect.width - offset,
      y: anchor.y - rect.height / 2,
      contentRect: rect,
      targetRect: targetRect,
      scrollRect: scrollRect,
      align: align,
      offset: offset
    });
  }), _alignedPosition);
  return alignedPosition[align]();
}; // The default value of 1.2 pixels for offset is to ensure a small overlap so that at certain browser zoom levels
// we do not see a slim piece of the underlying content (Popover.Card border)


exports.getContentCoordinates = getContentCoordinates;

var getTipCoordinates = function getTipCoordinates(_ref3) {
  var tipRect = _ref3.tipRect,
      targetRect = _ref3.targetRect,
      contentRect = _ref3.contentRect,
      contentCoords = _ref3.contentCoords,
      align = _ref3.align,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? -1.2 : _ref3$offset;
  var alignedPosition = {
    top: function top() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y + contentRect.height + offset
      };
    },
    right: function right() {
      return {
        x: contentCoords.x - tipRect.width - offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    },
    bottom: function bottom() {
      return {
        x: targetRect.x + targetRect.width / 2 - tipRect.width / 2,
        y: contentCoords.y - tipRect.height - offset
      };
    },
    left: function left() {
      return {
        x: contentCoords.x + contentRect.width + offset,
        y: targetRect.y + targetRect.height / 2 - tipRect.height / 2
      };
    }
  };
  var tipAlign = {
    top: function top() {
      return contentCoords.y > targetRect.y ? "bottom" : align;
    },
    right: function right() {
      return contentCoords.x < targetRect.x ? "left" : align;
    },
    bottom: function bottom() {
      return contentCoords.y < targetRect.y ? "top" : align;
    },
    left: function left() {
      return contentCoords.x > targetRect.x ? "right" : align;
    }
  };
  var adjustedAlign = tipAlign[align]();
  return _objectSpread(_objectSpread({}, alignedPosition[adjustedAlign]()), {}, {
    rotate: rotate[adjustedAlign]
  });
};

exports.getTipCoordinates = getTipCoordinates;
//# sourceMappingURL=getPosition.js.map